var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { forwardRef } from 'react';
import classNames from 'classnames';
import styles from './styles.module.scss';
import { withAliases } from '../../../ui/utils/with-aliases';
import { TextM, LinkM, TextS, LinkS } from '../typography/typography';
import Loader from '../../icons/loader.svg';
var BaseButton = forwardRef(function (_a, ref) {
    var _b;
    var _c = _a.variant, variant = _c === void 0 ? 'primary' : _c, color = _a.color, _d = _a.size, size = _d === void 0 ? 'default' : _d, _e = _a.fullWidth, fullWidth = _e === void 0 ? false : _e, _f = _a.loading, loading = _f === void 0 ? false : _f, _g = _a.disabled, disabled = _g === void 0 ? false : _g, startIcon = _a.startIcon, endIcon = _a.endIcon, className = _a.className, children = _a.children, _h = _a.type, type = _h === void 0 ? 'button' : _h, _j = _a.noWrap, noWrap = _j === void 0 ? false : _j, rest = __rest(_a, ["variant", "color", "size", "fullWidth", "loading", "disabled", "startIcon", "endIcon", "className", "children", "type", "noWrap"]);
    var buttonClasses = classNames(styles.button, styles["button--".concat(variant)], styles["button--".concat(size)], (_b = {},
        _b[styles['button--fullWidth']] = fullWidth,
        _b[styles['button--loading']] = loading,
        _b[styles['button--disabled']] = disabled || loading,
        _b[styles['button--nowrap']] = noWrap,
        _b), className);
    var renderContent = function () {
        if (variant === 'text') {
            if (size === 'small') {
                return _jsx(LinkS, { color: color, children: children });
            }
            return _jsx(LinkM, { color: color, children: children });
        }
        if (size === 'small') {
            return (_jsx(TextS, { color: color, className: "text-strong", children: children }));
        }
        return (_jsx(TextM, { color: color, className: "text-strong", children: children }));
    };
    return (_jsxs("button", __assign({ className: buttonClasses, disabled: disabled || loading, type: type }, rest, { ref: ref, children: [loading && (_jsx("div", { className: styles['loading-spinner'], children: _jsx(Loader, {}) })), startIcon && _jsx("div", { className: styles['start-icon'], children: startIcon }), children && _jsx("div", { className: styles.content, children: renderContent() }), endIcon && _jsx("div", { className: styles['end-icon'], children: endIcon })] })));
});
BaseButton.displayName = 'BaseButton';
var Primary = forwardRef(function (props, ref) { return (_jsx(BaseButton, __assign({ variant: "primary" }, props, { ref: ref }))); });
Primary.displayName = 'PrimaryButton';
var Secondary = forwardRef(function (props, ref) { return (_jsx(BaseButton, __assign({ variant: "secondary" }, props, { ref: ref }))); });
Secondary.displayName = 'SecondaryButton';
var SecondarySmall = forwardRef(function (props, ref) { return _jsx(BaseButton, __assign({ variant: "secondary", size: "small" }, props, { ref: ref })); });
SecondarySmall.displayName = 'SecondarySmallButton';
var TextLink = forwardRef(function (props, ref) { return (_jsx(BaseButton, __assign({ variant: "text" }, props, { ref: ref }))); });
TextLink.displayName = 'TextLinkButton';
var TextLinkSmall = forwardRef(function (props, ref) { return _jsx(BaseButton, __assign({ variant: "text", size: "small" }, props, { ref: ref })); });
TextLinkSmall.displayName = 'TextLinkSmall';
export var Button = withAliases(BaseButton, {
    Primary: Primary,
    Secondary: Secondary,
    SecondarySmall: SecondarySmall,
    TextLink: TextLink,
    TextLinkSmall: TextLinkSmall,
});
